/**
 * Role string for API bodies that gate Admin / Super Admin behavior (e.g. getTask).
 * Prefer Admin/Super Admin when present in roles[] so list endpoints return full account data.
 *
 * @param {{ role?: string, roles?: string[] } | null | undefined} userInfo
 * @returns {string}
 */
export function getApiRoleFromUserInfo(userInfo) {
  if (!userInfo) return "";
  const roles = Array.isArray(userInfo.roles)
    ? userInfo.roles.map((r) => String(r).trim()).filter(Boolean)
    : [];
  if (roles.includes("Super Admin")) return "Super Admin";
  if (roles.includes("Admin")) return "Admin";
  const single = userInfo.role != null ? String(userInfo.role).trim() : "";
  if (single) return single;
  return roles[0] || "";
}
